import { Component, ElementRef } from "@angular/core";
import { Broadcaster } from "../service/Broadcaster";
import { SingService } from "../service/sing.service";
import { RenameService } from "./services/rename.service";
import { renameCategori } from "../class/broadcaster/rename/rename-categori";
import { renameProduct } from "../class/broadcaster/rename/rename-product";
import { Rename } from "../class/rename/rename";
import { responseUpdateCategory } from "../class/http/res/response-update-category";
import { renameSetProduct } from "../class/broadcaster/rename/rename-set-product";
import { renameSetCategori } from "../class/broadcaster/rename/rename-set-categori";
@Component({
    selector: "rename-comp",
    templateUrl: "html/rename.component.html",
    styleUrls: ["css/rename.component.css"],
    providers: [SingService,RenameService]
})
export class RenameComponent {
    class: string = "";
    display: string = "none";
    name: string = "";
    title: string = "";
    constructor(private broadcaster: Broadcaster, private elRef: ElementRef, private httpService: SingService, private action:RenameService ) { }
    ngOnInit() {

        this.broadcaster.on<any>("renameCategori").subscribe((data:renameCategori) => {

            if (data.action && data.action === "closed") {
                this.ClosedAll();
                return;
            }
            this.action.editProduct = false;
            this.action.editCategori = true;
            this.action.categori = data.categori;
            this.name = this.action.categori.title;
            this.action.indexCat = data.i;
            this.title = "Category";
            this.class = "m--fade";
            this.display = "block";
           this.action.show();
        });
        this.broadcaster.on<any>("renameProduct").subscribe((data:renameProduct) => {
            this.action.product = data.product;
            this.name = this.action.product.title;
            this.action.indexCat = data.i;
            this.action.indexProduct = data.u;
            this.action.editProduct = true;
            this.action.editCategori = false;
            this.title = "Product";
            this.class = "m--fade";
            this.display = "block";
            this.action.show();

        });


    }


    ClosedAll() {
        if (this.display === "block") {
            this.display = "none";
            this.class = "";
            (<HTMLElement>document.body.querySelector(".allwhite")).style.display = "none";
            document.body.querySelector("main").classList.remove("m--blur");

        }

    }


    Save() {
        if (this.name === "") return;
        let data:Rename = new Rename((this.action.editCategori) ? String(this.action.categori.id).split("categories-").join("") : String(this.action.product.id).split("products-").join(""),this.name)
        if (this.action.editCategori) {
            this.action.updateCategory(data)
                .subscribe((res:responseUpdateCategory) => {
                        this.ClosedAll();
                        this.broadcaster.broadcast("renameSetCategori",new renameSetCategori (this.action.indexCat,this.name));
                });
        }
        if (this.action.editProduct) {
            this.action.updateProduct(data)
                .subscribe((res:responseUpdateCategory) => {
                        this.ClosedAll();
                        this.broadcaster.broadcast("renameSetProduct", new renameSetProduct(this.action.indexProduct,this.action.indexCat,this.name) );
                });
        }

    }


}



// WEBPACK FOOTER //
// ./src/app/components/rename/rename.component.ts